import { CodeBlock, Fig, Figs, GuideMemo, Related } from "./memoUi";

export function AboutMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "what", label: "Что это" },
        { id: "algo", label: "Алгоритм" },
        { id: "role", label: "Трафик-менеджер" },
        { id: "team", label: "Отделы" },
      ]}
    >
      <section className="Memos-section" id="what">
        <h2>Программатик — это</h2>
        <p>
          Канал медийной рекламы: аукцион показывает баннер или видео нужному типу пользователей через
          автоматическую платформу на партнёрских SSP. Через взаимодействие рекламы с сайтом клиента
          собирается бигдата. Цель — найти из посетителей сайта тех, на кого имеет смысл настраивать
          ретаргетинг.
        </p>
        <p>
          Для нашей системы ретаргетинг — дополнительный инструмент внутри технологии, не основной канал.
        </p>
      </section>
      <section className="Memos-section" id="algo">
        <h2>Как работает алгоритм</h2>
        <ol>
          <li>Ведём новую аудиторию по согласованному портрету.</li>
          <li>Робот-предиктор уточняет портрет и ищет похожих.</li>
          <li>
            Догоняем только тех, кто был на сайте и подходит под портрет покупателя.
          </li>
        </ol>
      </section>
      <section className="Memos-section" id="role">
        <h2>Трафик-менеджер</h2>
        <p>
          Performance-маркетолог: приводит целевой трафик на сайт или лендинг через платные каналы.
          Задача не «нагнать клики», а привести людей к нужному действию при бюджете и KPI.
        </p>
        <p>На входе медиаплан и задачи по кликам или показам. Дальше кампании настраиваются, ведутся и сверяются с Метрикой.</p>
        <h3>Основные обязанности</h3>
        <ul>
          <li>Настраивать рекламные кампании и следить за плановыми KPI</li>
          <li>Оптимизировать РК</li>
          <li>Ежедневно заполнять отчёт производства в админке</li>
          <li>Регистрировать баннеры в Медиаскауте (ОРД)</li>
          <li>Создавать чаты для новых клиентов</li>
          <li>Формировать отчёты</li>
        </ul>
      </section>
      <section className="Memos-section" id="team">
        <h2>Отделы</h2>
        <div className="Memos-macros">
          <div>
            <h3>Продажи</h3>
            <p>С производством почти не пересекаются.</p>
          </div>
          <div>
            <h3>Аккаунтинг</h3>
            <p>
              Даёт информацию по клиенту в чате, курирует процессы, ставит задачи производству.
              На проекте обычно два аккаунт-менеджера.
            </p>
          </div>
          <div>
            <h3>Производство</h3>
            <p>
              Контекстологи и трафик-менеджеры. Выполняют задачи, пишут в чат изменения настроек,
              оптимизацию и ожидания.
            </p>
          </div>
          <div>
            <h3>Разработка</h3>
            <p>Ошибки админки и ЛК сразу отправляйте в чат разработчиков.</p>
          </div>
        </div>
        <p>
          На лидген-проекте обычно есть контекстолог. Если лидогенерации нет, кабинет Директа не нужен.
        </p>
        <Related
          items={[
            { to: "/admin/memos/glossary", label: "Словарь и каналы" },
            { to: "/admin/memos/admin", label: "Админка" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}

export function GlossaryMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "words", label: "Словарь" },
        { id: "prg", label: "Коды PRG" },
        { id: "tools", label: "Сервисы" },
      ]}
    >
      <section className="Memos-section" id="words">
        <h2>Внутренние обозначения</h2>
        <div className="Memos-tableWrap">
          <table className="Memos-table">
            <thead>
              <tr>
                <th>Слово</th>
                <th>Значение</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Доп траф</td>
                <td>Дополнительный трафик, которым занимаются трафик-менеджеры</td>
              </tr>
              <tr>
                <td>КТ</td>
                <td>Точка контроля: отчёт об оптимизации, следующая дата и ожидание</td>
              </tr>
              <tr>
                <td>ОС</td>
                <td>Обратная связь</td>
              </tr>
              <tr>
                <td>Окнуть</td>
                <td>Одобрить, «всё в порядке»</td>
              </tr>
              <tr>
                <td>Апнуть</td>
                <td>Переслать сообщение в чате, напомнить</td>
              </tr>
              <tr>
                <td>Тэгнуть</td>
                <td>Отметить человека в Telegram</td>
              </tr>
              <tr>
                <td>Созвон</td>
                <td>Встреча в Телемосте или по ссылке из календаря</td>
              </tr>
              <tr>
                <td>РК</td>
                <td>Рекламная кампания</td>
              </tr>
              <tr>
                <td>РР / RR</td>
                <td>Ранрейт — основной показатель в админке</td>
              </tr>
              <tr>
                <td>ОП</td>
                <td>Отчёт производства</td>
              </tr>
              <tr>
                <td>PPT</td>
                <td>Контекст</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className="Memos-section" id="prg">
        <h2>Коды каналов</h2>
        <p>
          В отчёте производства коды такие. На <b>Retargeo</b> для доп. трафика ставим PRG4, PRG5 и PRG7 —
          так отличаем площадки между собой, даже если в ОП те же номера заняты SSP.
        </p>
        <div className="Memos-tableWrap">
          <table className="Memos-table">
            <thead>
              <tr>
                <th>Код</th>
                <th>Кто ведёт</th>
                <th>Канал</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>PRG1</td>
                <td>Контекст</td>
                <td>Поиск</td>
              </tr>
              <tr>
                <td>PRG2</td>
                <td>Контекст</td>
                <td>РСЯ</td>
              </tr>
              <tr>
                <td>PRG12</td>
                <td>Контекст</td>
                <td>Мастер кампаний, смесь поиска и РСЯ</td>
              </tr>
              <tr>
                <td>PRG4, PRG5, PRG7</td>
                <td>Трафик</td>
                <td>SSP в ОП. На Retargeo — метки доп. трафика</td>
              </tr>
              <tr>
                <td>PRG8</td>
                <td>Трафик</td>
                <td>Инволтра</td>
              </tr>
              <tr>
                <td>PRG80</td>
                <td>Трафик</td>
                <td>MyBid</td>
              </tr>
              <tr>
                <td>PRG81</td>
                <td>Трафик</td>
                <td>RichAds</td>
              </tr>
              <tr>
                <td>PRG82</td>
                <td>Трафик</td>
                <td>ZeroPark</td>
              </tr>
              <tr>
                <td>PRG84</td>
                <td>Трафик</td>
                <td>Bid</td>
              </tr>
              <tr>
                <td>PRG86</td>
                <td>Трафик</td>
                <td>Sape</td>
              </tr>
              <tr>
                <td>PRG87</td>
                <td>Трафик</td>
                <td>Getintent</td>
              </tr>
              <tr>
                <td>PRG88</td>
                <td>Трафик</td>
                <td>Hybrid</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className="Memos-section" id="tools">
        <h2>С чем работаем</h2>
        <ul>
          <li>Админка и ЛК Programmatic / Retargeo</li>
          <li>Медиаскаут — ОРД</li>
          <li>Метрика, Яндекс Медиа Метрика, Директ, почта, календарь, Телемост</li>
          <li>Таблицы доступов и «Новый ФЗ» — логины только там, не в памятках</li>
        </ul>
        <Related
          items={[
            { to: "/admin/memos/about", label: "Роль и отделы" },
            { to: "/admin/memos/markup", label: "Разметка" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}

export function AdminMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "where", label: "Где что лежит" },
        { id: "header", label: "Шапка проекта" },
        { id: "op", label: "Отчёт производства" },
      ]}
    >
      <section className="Memos-section" id="where">
        <h2>Админка</h2>
        <p>
          Личный кабинет, админка и отчёт производства — разные названия одного контура: данные проектов
          и SSP-платформа. Каждый день производство заполняет отчёт за вчера: траты, на части проектов —
          ещё и клики из Метрики вручную.
        </p>
        <p>
          Админка часто в доработках: «криво собрался период», «слетели цели». Такое сразу пишите разработчикам.
        </p>
        <Fig n={1} caption="Вкладка «Отчёт производства»: список проектов, KPI и статус цикла" />
        <Figs
          cols={2}
          items={[
            { n: 2, caption: "Шапка, свод, детализация и лимиты внутри проекта" },
            { n: 3, caption: "Выгрузка лимитов — с ней сверяют таблицу открутки" },
          ]}
        />
        <Fig n={4} caption="Лимиты в письме и в админке должны совпадать с тем, что ставите в каналах" />
      </section>
      <section className="Memos-section" id="header">
        <h2>Шапка проекта</h2>
        <p>
          Здесь главные поля: сайт, даты цикла, цель РК, гео, счётчик Метрики, номера целей и посадочные.
          Клиент часто продлевается каждый месяц — KPI ставят на новый цикл.
        </p>
        <p>
          Свод показывает план/факт по кликам, лидам, расход и доход. По нему смотрят, как проект себя чувствовал вчера.
        </p>
      </section>
      <section className="Memos-section" id="op">
        <h2>Детализация, лимиты, графики</h2>
        <p>
          Детализация — отчёт, который заполняют. Можно выбрать дату и отдельный канал.
          Лимиты считают рекомендуемое число кликов. Если ранрейт по кликам уже выполнен и даты цикла прошли,
          в лимите будет −1: начинается новый цикл. Лимиты выставляют аккаунты, они же приходят в выгрузке на почту.
        </p>
        <Fig n={5} caption="Графики: динамика проекта, даты и каналы можно переключать" />
        <p>
          Строчку проекта в ОП создают из «Клиенты»: пролистать вправо → «Создать» в столбце «Отчёт».
          В шапке назначьте аккаунтов, трафика и контекстолога. Привяжите охватные РК: иначе показы в админку
          подтянутся неправильно. Если на проекте CPC и CPM — две строчки и две привязки.
        </p>
        <Figs
          cols={2}
          items={[
            { n: 44, caption: "Создание строчки отчёта у клиента" },
            { n: 45, caption: "Название как в чате, при необходимости дублировать под CPC/CPM" },
            { n: 46, caption: "Ответственные в шапке проекта" },
          ]}
        />
        <Related
          items={[
            { to: "/admin/memos/launch", label: "Запуск клиента" },
            { to: "/admin/memos/glossary", label: "Коды PRG" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}

export function LaunchMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "chat", label: "Чат" },
        { id: "lk", label: "Кабинет" },
        { id: "campaign", label: "Охватная РК" },
        { id: "balance", label: "Баланс и включение" },
      ]}
    >
      <section className="Memos-section" id="chat">
        <h2>Создание чата</h2>
        <p>
          В чат «Акк+Производство» приходит запрос: название, посадочная, стратегия, гео, бюджет и ответственные.
        </p>
        <Fig n={26} caption="Пример запроса на создание чата: из него берётся название и вводные" />
        <p>Новая группа. Название — из сообщения. Всегда добавляем:</p>
        <ul>
          <li>Мария Казакевич — админ</li>
          <li>Мария Лайцан</li>
          <li>Дмитрий Таксер — владелец</li>
          <li>Трафик-менеджер и оба аккаунт-менеджера</li>
        </ul>
        <p>
          История чата «видна». В описание — гео и посадочные. На аватар — логотип. Перешлите в чат исходный запрос,
          тестовую ссылку и файл PTM.
        </p>
        <CodeBlock
          label="Тестовая ссылка"
          value={"https://посадочная/?utm_source=Programmatic&utm_medium=test"}
        />
      </section>
      <section className="Memos-section" id="lk">
        <h2>Личный кабинет клиента</h2>
        <ol>
          <li>Почта в Outlook: логин — сайт проекта, имя — юрлицо. Пароль сохраните себе, им же регистрируете ЛК.</li>
          <li>
            Регистрация только по{" "}
            <a href="https://lk.programmatic.ru/sign-up/manager">lk.programmatic.ru/sign-up/manager</a>
            {" "}— иностранная почта через обычную форму не пройдёт.
          </li>
          <li>Имя — адрес сайта (знаки препинания в пробелы). Фамилия — юрлицо. Всегда «Я юридическое лицо».</li>
          <li>ИНН из таблицы «Новый ФЗ» или у аккаунта. Телефон можно произвольный.</li>
          <li>Подтвердите регистрацию из письма.</li>
          <li>Занесите проект во вкладку «ЛК Programmatic» таблицы доступов.</li>
        </ol>
        <Figs
          cols={2}
          items={[
            { n: 28, caption: "После регистрации нужно подтвердить почту" },
            { n: 29, caption: "Письмо со ссылкой подтверждения" },
          ]}
        />
        <p>
          Счётчики: «Привязать аккаунт» → войти в служебный Яндекс → «Добавить счётчик» по номеру или названию из брифа.
        </p>
        <Fig n={30} caption="Привязка аккаунта Метрики в кабинете" />
      </section>
      <section className="Memos-section" id="campaign">
        <h2>Охватная кампания</h2>
        <p>
          «Добавить кампанию». Название — как в чате плюс модель оплаты, если CPC и CPM разделены.
          Посадочная из чата. Бюджеты — из медиаплана. Распределение обычно «Эффективное».
          Счётчик — тот, что только что добавили.
        </p>
        <p>
          Если в медиаплане есть и CPC, и CPM — создавайте две РК. На чистом охвате без лидгена после создания
          РК сразу берите итоговую ссылку для площадок.
        </p>
        <Figs
          cols={2}
          items={[
            { n: 31, caption: "Основные настройки РК" },
            { n: 32, caption: "Бюджет и счётчик" },
            { n: 33, caption: "Медиаплан: дни цикла и «Выбрать все периоды», если нет особых окон" },
            { n: 34, caption: "Вкладка объявлений" },
          ]}
        />
        <p>
          В объявлении: баннеры, разные заголовки на каждое объявление, посадочная.
          Шаблон UTM — только из памятки «Разметка», не из старых скринов. Скрин ниже показывает кнопку итоговой ссылки,
          но схема меток на нём уже не актуальная.
        </p>
        <Fig n={35} caption="Частотность и цели ретаргетинга. Если цели не выбрать, система уйдёт в look-alike" />
        <p>
          Оптимизация: по умолчанию CPM и минимальная ставка 120 ₽ за 1000 показов — так и в кабинете.
          Если у клиента нет доступа в ЛК, это можно оставить. Если доступ есть — тип оплаты и ставку берите из медиаплана.
        </p>
        <Figs
          cols={2}
          items={[
            { n: 36, caption: "Оптимизация и ставка" },
            { n: 37, caption: "Сегмент из брифа, затем выбор из сохранённых" },
          ]}
        />
      </section>
      <section className="Memos-section" id="balance">
        <h2>Пополнение и включение</h2>
        <p>
          Админка → Клиенты → карандаш у баланса → «Пополнение».
          Сумма: план показов / 1000 × 120 или сумма из медиаплана, обычно без НДС.
        </p>
        <Figs
          cols={2}
          items={[
            { n: 38, caption: "Клиенты: найти проект" },
            { n: 39, caption: "Пополнение баланса" },
          ]}
        />
        <p>
          На «Кампании» проверьте положительный баланс, включите РК и объявления — так они уходят на модерацию.
          Реквизиты клиента заполните во вкладке банковских реквизитов профиля, данные из чата проекта.
        </p>
        <Figs
          cols={2}
          items={[
            { n: 40, caption: "Профиль аккаунта" },
            { n: 41, caption: "Банковские реквизиты" },
            { n: 42, caption: "Включённая РК после модерации баннеров" },
          ]}
        />
        <Related
          items={[
            { to: "/admin/memos/markup", label: "Разметка" },
            { to: "/admin/memos/moderation", label: "Модерация и ЕРИД" },
            { to: "/admin/memos/direct", label: "Директ" },
            { to: "/admin/memos/extra-traffic", label: "Доп. трафик" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}

export function DirectMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "new", label: "Новый клиент" },
        { id: "data", label: "Данные рекламодателя" },
      ]}
    >
      <section className="Memos-section" id="new">
        <h2>Регистрация кабинета Директа</h2>
        <p>
          Нужен только если на проекте есть лидогенерация. Заходите под красным аккаунтом Programmatic-ru.
          «Мои клиенты» → вниз страницы → «Регистрация нового клиента».
        </p>
        <Figs
          cols={2}
          items={[
            { n: 6, caption: "Ссылка «Регистрация нового клиента» внизу списка" },
            { n: 47, caption: "Тот же шаг из другого места гайда: список клиентов Директа" },
            { n: 7, caption: "Название организации — сайт или проект, не юрлицо" },
            { n: 8, caption: "ИНН рекламодателя" },
            { n: 48, caption: "Почта всегда Programmatic-ru. Название — домен без https" },
          ]}
        />
        <p>
          Несколько проектов одного юрлица путаются, если везде писать одно юрлицо. В названии кабинета — сайт.
        </p>
      </section>
      <section className="Memos-section" id="data">
        <h2>Данные рекламодателя и договор</h2>
        <p>
          Настройки → «Данные рекламодателя». КПП можно пропустить. Снимите «Я — конечный рекламодатель».
          ИНН агентства подставляйте по договору: Бизнес Солюшенс, Программатик или ИП — смотрите, с кем договор.
          Номер и даты договора — из «Новый ФЗ».
        </p>
        <Figs
          cols={2}
          items={[
            { n: 9, caption: "Вкладка «Данные рекламодателя»" },
            { n: 10, caption: "Снять галочку конечного рекламодателя, подтянуть агентство по ИНН" },
            { n: 11, caption: "Сохранить и закрепить логин в чате" },
            { n: 49, caption: "Данные рекламодателя, агентства и плательщика" },
          ]}
        />
        <p>
          Логин и название отправьте в чат проекта — кабинет забирает контекстолог.
          Добавьте строку в «Доступы для производства».
        </p>
        <Related
          items={[
            { to: "/admin/memos/launch", label: "Запуск клиента" },
            { to: "/admin/memos/ord", label: "ОРД" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}

export function ModerationMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "flow", label: "Как модерировать" },
        { id: "erid", label: "ЕРИД" },
      ]}
    >
      <section className="Memos-section" id="flow">
        <h2>Модерация объявлений</h2>
        <p>
          Баннеры падают во вкладку «Модерация». Ищите клиента по названию РК. Откройте объявления,
          вставьте ЕРИД, нажмите «Проверить», при успехе — «Одобрить».
        </p>
        <Fig n={43} caption="ЕРИД, проверка и одобрение. Ссылка для внешних систем копируется отсюда же" />
        <p>
          Кампания едет, когда включена сама РК и одобрены объявления. Бывает, клиент отправил баннеры,
          но РК не включил — тогда ждите включения.
        </p>
      </section>
      <section className="Memos-section" id="erid">
        <h2>Проверка ЕРИД</h2>
        <p>
          ЕРИД получаете при регистрации креатива в ОРД. Система сверяет токен с ИНН в банковских реквизитах ЛК.
          Зелёное окно — токен корректный. Красное — проверьте ЕРИД и карточку реквизитов.
        </p>
        <p>Без проверенного ЕРИД одобрять нельзя.</p>
        <Related
          items={[
            { to: "/admin/memos/ord", label: "Как получить ЕРИД в ОРД" },
            { to: "/admin/memos/retargeo", label: "Модерация Retargeo" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}

export function RetargetingMemo() {
  return (
    <GuideMemo
      sections={[
        { id: "goals", label: "Цели" },
        { id: "dynamic", label: "Динамический" },
        { id: "mark", label: "Разметка" },
      ]}
    >
      <section className="Memos-section" id="goals">
        <h2>Медийный ретаргетинг</h2>
        <p>
          Если клиент просит ретаргет — запускаем охват с настройками 100% ретаргета, если нет ограничений
          на использование Директа.
        </p>
        <p>
          Во вкладке «Ретаргетинг» обязательно выставьте цели. Без целей система работает только как look-alike.
          Частотность берите из медиаплана.
        </p>
        <Fig n={35} caption="Цели, частотность, доля ретаргета и look-alike" />
        <Fig n={125} caption="Настройки ретаргета на охватной РК" />
      </section>
      <section className="Memos-section" id="dynamic">
        <h2>Динамический ретаргетинг</h2>
        <p>
          Включается по запросу. Площадка — Я.Метрика. Для выбранной цели можно повесить конкретное объявление
          и исключить ненужные цели.
        </p>
        <Figs
          cols={2}
          items={[
            { n: 126, caption: "Включить динамический ретаргет и выбрать Метрику" },
            { n: 127, caption: "Цель + объявление = триггер" },
          ]}
        />
      </section>
      <section className="Memos-section" id="mark">
        <h2>Метки</h2>
        <p>
          Шаблон тот же, что у обычной охватки. Если нужно пометить ретаргет в тексте меток, используют PRGr.
          Сами макросы id не переставляйте — актуальные правила в памятке «Разметка».
        </p>
        <Related
          items={[
            { to: "/admin/memos/markup", label: "Разметка" },
            { to: "/admin/memos/launch", label: "Создание РК" },
          ]}
        />
      </section>
    </GuideMemo>
  );
}
